<template>
  <v-dialog v-model="isOpened" @cancel="onCancel">
    <v-card>
      <v-toolbar flat color="primary" dark>
        <template #prepend>
          <v-icon>mdi-button-cursor</v-icon>
        </template>
        <v-toolbar-title>
          <v-text-field
              :class="['mr-2', pendingButtonName ? 'd-block' : 'd-none']"
              variant="outlined"
              density="compact"
              placeholder="버튼명"
              hide-details
              ref="buttonNameEl"
              v-model="buttonName"
              @focusout="pendingButtonName = false"
              @keyup.enter="pendingButtonName = false"
          ></v-text-field>
          <span
              :class="['mr-2', !pendingButtonName ? 'd-block' : 'd-none']"
              @click="onEditName">{{ buttonName || '버튼명을 입력하세요' }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-item>
        <v-text-field v-model="buttonDescription" density="compact" hide-details placeholder="버튼 설명을 입력하세요."></v-text-field>
      </v-card-item>
      <v-card-item>
        <div class="d-flex flex-column" style="min-height: 400px;margin: -8px;">
          <div class="d-flex flex-column flex-1-0" style="position: relative;">
            <span class="ma-2" style="position: absolute;left: 16px;background-color: #f3f3f3;">
              실행절차
            </span>
            <div class="ma-2 mt-4 pa-2 pt-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px">
              <div class="d-flex flex-wrap" style="margin: -4px;">
                <draggable v-model="steps" item-key="id">
                  <template #item="{element, index}">
                    <v-chip
                        class="ma-1 flex-0-0" :color="element.type === 'command' ? 'red-darken-4' : 'grey-darken-4'"
                        :key="element.id"
                        @click.stop="() => onTask(index)">
                        {{ element.name }}
                    </v-chip>
                  </template>
                </draggable>
              </div>
            </div>
          </div>
          <div style="position: relative;">
            <span class="ma-2" style="position: absolute;left: 16px;background-color: #f3f3f3;">
              제어 명령
            </span>
            <div class="ma-2 mt-4 pa-2 pt-4" style="border: 1px solid #e0e0e0;border-radius: 5px">
              <div class="d-flex flex-wrap" style="margin: -4px;">
                <template :key="command.id" v-for="command in commands">
                  <v-chip
                      color="red-darken-4"
                      class="ma-1 flex-0-0"
                      @click.stop="onCommand(command.id)">
                    <template v-if="command.id === CREATE_COMMAND_NAME">
                      <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                      {{ command.name }}
                    </template>
                  </v-chip>
                </template>
              </div>
            </div>
          </div>
          <div style="position: relative;">
            <span class="ma-2" style="position: absolute;left: 16px;background-color: #f3f3f3;">
              시간 명령
            </span>
            <div class="ma-2 mt-4 pa-2 pt-4" style="border: 1px solid #e0e0e0;border-radius: 5px">
              <div class="d-flex align-center" style="margin: -8px;">
                <v-chip color="grey-darken-4" class="ma-2" @click="onTimeout(60 * 60)">
                  1시간
                </v-chip>
                <v-chip color="grey-darken-4" class="ma-2" @click="onTimeout(5 * 60)">
                  5분
                </v-chip>
                <v-chip color="grey-darken-4" class="ma-2" @click="onTimeout(60)">
                  1분
                </v-chip>
                <v-chip color="grey-darken-4" class="ma-2" @click="onTimeout(5)">
                  5초
                </v-chip>
                <v-chip color="grey-darken-4" class="ma-2" @click="onTimeout(1)">
                  1초
                </v-chip>
                <v-menu location="top" v-if="false">
                  <template v-slot:activator="{ props }">
                    <v-chip class="ma-2" v-bind="props">
                      시간
                    </v-chip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(item, index) in [6, 5, 4, 3, 2, 1]"
                        :key="index" :value="index"
                        @click="onTimeout(item * 60 * 60)"
                    >
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu location="top" v-if="false">
                  <template v-slot:activator="{ props }">
                    <v-chip class="ma-2" v-bind="props">
                      분
                    </v-chip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(item, index) in  [50, 40, 30, 20, 10]"
                        :key="index" :value="index"
                        @click="onTimeout(item * 60)"
                    >
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu location="top" v-if="false">
                  <template v-slot:activator="{ props }">
                    <v-chip class="ma-2" v-bind="props">
                      초
                    </v-chip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(item, index) in  [50, 40, 30, 20, 10]"
                        :key="index" :value="index"
                        @click="onTimeout(item)"
                    >
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
      </v-card-item>
      <v-card-actions>
        <v-btn variant="tonal" @click="onDelete" v-if="props.modelValue.id !== CREATE_BUTTON_NAME">삭제</v-btn>
        <v-spacer></v-spacer>
        <v-btn variant="tonal" @click="onCancel">취소</v-btn>
        <v-btn variant="tonal" @click="onOk">확인</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import {defineProps, reactive, ref, toRaw, computed, watch, nextTick} from "vue";
import draggable from 'vuedraggable';
import {CREATE_BUTTON_NAME, CREATE_COMMAND_NAME} from "@/common/constants";

const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue', 'onCancel', 'onOk']);

const pendingButtonName = ref(false);
const buttonName = ref(toRaw(props.modelValue.name));
const buttonNameEl = ref(null);
const buttonDescription = ref(toRaw(props.modelValue.description));
const steps = ref(props.modelValue.steps);
const commands = ref(props.modelValue.commands);

const isOpened = ref(true);

const dialog = reactive({
  command: {
    isOpened: false,
  }
});

watch(isOpened, (newValue, oldValue) => {
  if (newValue || !oldValue) return;
  onCancel();
});

const onEditName = () => {
  pendingButtonName.value = true;
  nextTick(() => {
    buttonNameEl.value.focus();
  });
};

const onTask = taskIndex => {
  steps.value = steps.value.filter((task, index) => index !== taskIndex);
};

const onCommand = async (commandId) => {
  const command = commands.value.find(({id}) => id === commandId);
  steps.value = [...steps.value, {type: 'command', name: command.name, commandId: command.id}];
};

const onTimeout = async timeout => {
  const [last, ...rest] = [...steps.value].reverse();
  if (last && last.type === 'timeout')
    steps.value = rest.reverse();

  const sum = (last && last.type === 'timeout' ? last.timeout : 0) + timeout;
  const hours = Math.floor(sum / 3600);
  const minutes = Math.floor((sum % 3600) / 60);
  const seconds = sum % 60;

  const texts = [hours && `${hours}시간`, minutes && `${minutes}분`, seconds && `${seconds}초`];
  const name = texts.filter(v => v).join(' ');
  steps.value = [...steps.value, {type: 'timeout', name: `${name} 후`, timeout: sum}]
};

const onDelete = () => {
  emit('onDelete');
};

const onCancel = () => {
  emit('onCancel');
};

const onOk = () => {
  if (!verify()) return;

  const updated = {
    ...props.modelValue,
    name: buttonName.value,
    description: buttonDescription.value,
    steps: steps.value
  };
  emit('update:modelValue', updated);
  emit('onOk', updated);
};

const verify = () => {
  if (!buttonName.value) {
    alert('버튼명을 입력하세요');
    return false;
  }
  if (!buttonDescription.value) {
    alert('버튼설명을 입력하세요');
    return false;
  }
  if (0 === steps.value.length) {
    alert('실행절차를 입력하세요');
    return false;
  }
  if (!steps.value.some(({type}) => type === 'command')) {
    alert('하나 이상의 제어명령을 추가하세요');
    return false;
  }
  return true;
};

</script>

<style scoped>

</style>
